import { Logo } from "@/components/logo";

import { Button } from "@/components/ui/button";
import { Link, useNavigate } from "@tanstack/react-router";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { useEffect, useState } from "react";

export function Navbar() {
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // const isMobile = useIsMobile();

  return (
    <header
      className={`fixed top-0 z-50 w-full transition-all duration-300 ${
        isScrolled ? "bg-white/70 backdrop-blur-md shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-12 md:h-16">
          <div className="flex items-center">
            <Logo
              className="h-6 w-auto"
              color={isScrolled ? "#6d28d9" : "#6d28d9"}
              onClick={() => navigate({ to: "/" })}
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <a
              href="#how-it-works"
              className="text-sm font-medium text-slate-700 hover:text-violet-700 transition-colors"
            >
              How It Works
            </a>
            <a
              href="#testimonials"
              className="text-sm font-medium text-slate-700 hover:text-violet-700 transition-colors"
            >
              Testimonials
            </a>
            <a
              href="#pricing"
              className="text-sm font-medium text-slate-700 hover:text-violet-700 transition-colors"
            >
              Pricing
            </a>
            <a
              href="#about"
              className="text-sm font-medium text-slate-700 hover:text-violet-700 transition-colors"
            >
              About
            </a>
            {/* <div className="h-5 w-px bg-slate-200 mx-2"></div> */}
            {/* <Button
              variant="ghost"
              className="text-sm font-medium text-slate-700 hover:text-violet-700 transition-colors"
            >
              Log In
            </Button> */}
            {/* <Button
              className="bg-violet-600 hover:bg-violet-700 text-white rounded-full"
              asChild
            >
              <Link to="/get-started">Get Started</Link>
            </Button> */}
          </nav>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <Button
              variant="ghost"
              size="icon"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="Toggle menu"
              className="text-slate-700"
            >
              {mobileMenuOpen ? (
                <X className="h-6 w-6" />
              ) : (
                <Menu className="h-6 w-6" />
              )}
            </Button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      <AnimatePresence>
        {mobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="md:hidden bg-white/95 backdrop-blur-md border-t"
          >
            <div className="px-4 py-2 space-y-1">
              <a
                href="#how-it-works"
                className="block py-3 text-base font-medium text-slate-700 hover:text-violet-700 transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                How It Works
              </a>
              <a
                href="#testimonials"
                className="block py-3 text-base font-medium text-slate-700 hover:text-violet-700 transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                Testimonials
              </a>
              <a
                href="#pricing"
                className="block py-3 text-base font-medium text-slate-700 hover:text-violet-700 transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                Pricing
              </a>
              <a
                href="#about"
                className="block py-3 text-base font-medium text-slate-700 hover:text-violet-700 transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                About
              </a>
              <div className="pt-4 pb-2 flex flex-col space-y-3">
                <Button
                  className="w-full justify-center bg-violet-600 hover:bg-violet-700 rounded-full"
                  asChild
                >
                  <Link to="/get-started">Get Started</Link>
                </Button>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
